//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/ShipDesign.js";
import "../no/NXObject.js";
let d=[[],[[["name","nodeObjects"],"AddRootNode",{},2,0],[[],"GetRootNode",{R_:{rootNode:"ShipDesign.NavigatorNode"}},0,0],[[],"RemoveRootNode",{},0,0],[["count"],"GetSelectedNodes",{R_:{selectedNodes:"ShipDesign.NavigatorNode[]"}},0,0],[["selectedNodes"],"SetSelectedNodes",{},1,0],[["selectedNode"],"SetLastSelectedNode",{},1,0],[[],"GetLastSelectedNode",{R_:{selectedNode:"ShipDesign.NavigatorNode"}},0,0]],[]];
SPLM.ShipDesign.NavigatorView = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ShipDesign.NavigatorView";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;